import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/sweetalert2'
import './plugins/scroll-to-vue'
import './plugins/notification-vue'
import './plugins/simple-alert-vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from "axios";
import mixin from './mixins';
import i18n from "./i18n";


Vue.config.productionTip = false;

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('freebe_token');
  config.headers.Authorization =  token;    

  return config;
});

new Vue({
  router,
  store,
  mixins: [mixin],
  i18n,
  render: h => h(App)
}).$mount('#app')
